import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        return (
          isAxiosError(error) && [502, 503, 504].includes(error.status ?? 0) && failureCount <= 3
        );
      },
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error(`Following error occurred for query ${query.queryKey}`, error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      console.error(`Following error occurred for mutation`, error);
    },
  }),
});
